(function () {
  class GambleSpin extends PIXI.Container {
    constructor() {
      super();

      this._screenDim = undefined;
      this.gambleActive = false;

      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._currentSpins = undefined;
      this._takeSpinsButton = undefined;
      this._arrow = undefined;
      this._gambleDisc = undefined;
      this._winAnim = undefined;
      this._touchToGamble = undefined;
      this._pointerFinger = undefined;
      this._fsText1 = undefined;
      this._fsText2 = undefined;
      this._fsText3 = undefined;
      this._winIntroAnim = undefined;

      this.moveFinger = false;
      this.fingerMoving = false;
      this.fingerTimer = undefined;

      this._winStartAngle = undefined;
      this._winEndAngle = undefined;
      this.loseStartAngle = undefined;
      this._loseEndAngle = undefined;

      this._currentWin = false;

      this._possibleValues = undefined;
      this._localFSIndex = 0;

      this.winAnimPositions = [];

      this.gambleWinSounds = ["gambleWin1", "gambleWin2"];
      this.gambleWinSoundIndex = 0;

      this._x3WinChance = 0;
      this._x4WinChance = 0;

      this.gemBurstAnim = undefined;
      this.blastAnim = undefined;
      this.emitter = undefined;

      let self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }

      if (this.moveFinger && !this.fingerMoving) {
        let self = this;
        this.fingerMoving = true;
        timerManager.addTimer(
          1000,
          function (progress) {
            self._pointerFinger.position.setX(
              self.fingerStartX + 20 * Math.abs(Math.sin(Math.PI * progress))
            );
          },
          function () {
            self.fingerMoving = false;
          }
        );
      }
    }

    gambleResultEvent(task) {
      console.log(task);
    }

    onLayoutComplete() {
      this._currentSpins = resourceManager.get(
        "gambleSpinContainer:GambleSpin:takeSpinsButton:takeSpinsButtonText"
      );
      this._nextSpins = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleWinNumberText"
      );
      this._betterLuckText = resourceManager.get(
        "gambleSpinContainer:GambleSpin:betterLuck"
      );

      this._fsText1 = resourceManager.get(
        "gambleSpinContainer:GambleSpin:freeSpinsNumber1"
      );
      this._fsText2 = resourceManager.get(
        "gambleSpinContainer:GambleSpin:freeSpinsNumber2"
      );
      this._fsText3 = resourceManager.get(
        "gambleSpinContainer:GambleSpin:freeSpinsNumber3"
      );

      this._winAnimIntroPositions = [];
      this._winAnimIntroPositions.push(this._fsText1.position.get());
      this._winAnimIntroPositions.push(this._fsText2.position.get());
      this._winAnimIntroPositions.push(this._fsText3.position.get());

      this._winIntroAnim = resourceManager.get(
        "gambleSpinContainer:GambleSpin:winGlow"
      );
      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[this._localFSIndex].x,
        this._winAnimIntroPositions[this._localFSIndex].y
      );

      this._winIntroAnimTween = null;

      this._takeSpinsButton = resourceManager.get(
        "gambleSpinContainer:GambleSpin:takeSpinsButton"
      );
      this._takeSpinsButton.mousedown = this._takeSpinsButton.touchstart =
        this.onClickedToContinue.bind(this);

      this._gambleButton = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleButtonContainer"
      );
      const gambleButton = new PIXI.Graphics()
        .beginFill(0x000000, 0)
        .drawCircle(0, 0, 100);
      this._gambleButton.addChild(gambleButton);

      this._gambleButton.mousedown = this._gambleButton.touchstart =
        this.onCommittedToGamble.bind(this);

      this._arrow = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleArrow"
      );

      this.gemBurstAnim = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gemAnim"
      );
      this.gemBurstAnim.gotoAndStop(0);
      this.blastAnim = resourceManager.get(
        "gambleSpinContainer:GambleSpin:blastAnim"
      );
      this.blastAnim.gotoAndStop(0);

      messageBus.subscribe("Gamble:Risk", this.onGambleRisk.bind(this));
      messageBus.subscribe("Gamble:Collect", this.onGambleCollect.bind(this));

      this._betterLuckText.visible = false;

      this.emitter = particleManager.createEmitter(
        "gamble_emitter",
        "gambleSpinContainer:GambleSpin:particlesContainer",
        0,
        0,
        false
      );
      this.emitter.particleEmitter.emit = false;
    }

    onGambleCollect() {
      this._takeSpinsButton.interactive = false;
      this.alpha = 1;
      this.visible = false;
      this.stateMachine.switchState("IDLE");
      this.gambleActive = false;

      soundManager.play("gambleCollect");
    }

    onGambleRisk() {
      this._gambleButton.interactive = false;
      this._takeSpinsButton.interactive = false;
      this.resetFinger();

      soundManager.play("gambleStart");
      soundManager.play("gambleSpin");
    }

    resetFinger() {
      if (this.fingerTimer !== undefined) {
        timerManager.stop(this.fingerTimer);
        this.fingerTimer = undefined;
      }

      this.moveFinger = false;
      this.fingerMoving = false;
      this.emitter.particleEmitter.emit = false;
      this.stateMachine.switchState("IDLE");
    }

    onCommittedToGamble() {
      messageBus.postImmediate("Gamble:Risk");
    }

    onClickedToContinue() {
      messageBus.postImmediate("Gamble:Collect");
    }

    setupWheel(winChance, loseChance) {
      const winPercentage = (winChance * 100) / (winChance + loseChance) / 100;
      const losePercentage = 1 - winPercentage;

      const graphics = resourceManager.get(
        "gambleSpinContainer:GambleSpin:gambleSegments"
      );
      graphics.clear();

      this._loseStartAngle = -(losePercentage * Math.PI * 2) / 2 + Math.PI / 2;
      this._loseEndAngle = (losePercentage * Math.PI * 2) / 2 + Math.PI / 2;
      this._winStartAngle = this._loseEndAngle;
      this._winEndAngle = this._loseEndAngle + winPercentage * Math.PI * 2;

      // Winning arc
      graphics.beginFill(0x00c800);
      graphics.lineStyle(0, 0xffffff);
      graphics.moveTo(0, 0);
      graphics.arc(0, 0, 90, this._winStartAngle, this._winEndAngle); // cx, cy, radius, startAngle, endAngle
      graphics.endFill();

      // Losing arc
      graphics.beginFill(0xc80000);
      graphics.lineStyle(0, 0xffffff);
      graphics.moveTo(0, 0);
      graphics.arc(0, 0, 90, this._loseStartAngle, this._loseEndAngle); // cx, cy, radius, startAngle, endAngle
      graphics.endFill();
    }

    resetGambleSpin(startPos) {
      this._localFSIndex = startPos;
      if (this._winIntroAnimTween) {
        this._winIntroAnimTween.kill();
        this._winIntroAnimTween = null;
      }
    }

    start(x3WinChance, x4WinChance, possibleValues, firstEntry) {
      this._betterLuckText.visible = false;
      this.gambleActive = true;

      // gamble spin - needs to set up the gamble wheel ( visually split of red/green based on probability )
      this._possibleValues = possibleValues;
      this._fsText1.text = this._possibleValues[0];
      this._fsText2.text = this._possibleValues[1];
      this._fsText3.text = this._possibleValues[2];

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[this._localFSIndex].x,
        this._winAnimIntroPositions[this._localFSIndex].y
      );

      if (this._winIntroAnimTween == null) {
        this._winIntroAnimTween = gsap.fromTo(
          this._winIntroAnim,
          3,
          {
            rotation: 0,
          },
          {
            rotation: 360,
            rotation: Math.PI * 2,
            repeat: -1,
            ease: "none",
          }
        );
      }

      this._currentSpins.setTranslationParameters(
        this._possibleValues[this._localFSIndex]
      );
      const highestPossibleWin =
        this._possibleValues[this._possibleValues.length - 1];

      if (this._possibleValues[this._localFSIndex] != highestPossibleWin) {
        this._nextSpins.text = Object.values(
          GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS
        )[this._localFSIndex + 1];
      }

      if (this._possibleValues[this._localFSIndex] !== highestPossibleWin) {
        this._takeSpinsButton.visible = true;
        this._gambleButton.visible = true;
      } else {
        this._takeSpinsButton.visible = true;
      }

      this.visible = true;
      this._possibleValues = possibleValues;

      resourceManager.get("gambleIntroContainer:GambleIntro").visible = false;
      resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer"
      ).visible = false;
      resourceManager.get("gambleSpinContainer:GambleSpin").visible = true;

      this._takeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;

      this._x3WinChance = x3WinChance;
      this._x4WinChance = x4WinChance;

      const currentScatterCount = Object.keys(
        GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS
      )[this._localFSIndex];
      const currentWinChance = this[`_x${currentScatterCount}WinChance`] ?? 0;
      const currentLoseChance = 1 - currentWinChance;

      this.setupWheel(currentWinChance, currentLoseChance);

      if (firstEntry) {
        this._arrow.rotation = Math.PI / 2; // first time point arrow horizontally
        this.gambleWinSoundIndex = 0;
      }

      // after five seconds move the finger
      this.resetFinger();

      this._currentSpins.setTranslationParameters(
        this._possibleValues[this._localFSIndex]
      );

      messageBus.postImmediate("Gamble:WaitForInput");
    }

    spinToResult(result, callback) {
      this._currentWin = result;
      this._resultShownCb = callback;
      this._takeSpinsButton.visible = false;
      this._gambleButton.visible = false;

      this.emitter.particleEmitter.emit = true;

      const totalSpins = 4; // number of times to spin the wheel the full 360
      const safetyAngle = 0.087;

      let spinAngle = undefined;
      if (this._currentWin) {
        spinAngle =
          this._winStartAngle +
          safetyAngle +
          gameController.rng.nextFloat() *
            (this._winEndAngle -
              safetyAngle -
              (this._winStartAngle + safetyAngle));
      } else {
        spinAngle =
          this._loseStartAngle +
          safetyAngle +
          gameController.rng.nextFloat() *
            (this._loseEndAngle -
              safetyAngle -
              (this._loseStartAngle + safetyAngle));
      }

      // NOTE: VERY VERY IMPORTANT - spin angle is in arc coordinates so 0 rad = 3pm, whereas the arrow sprite 0 rad = 12pm
      // arrow needs to land at spin angle + PI/2

      const totalSpinDistance =
        totalSpins * Math.PI * 2.0 + spinAngle + Math.PI / 2; // pi/2 as we need to start at 3pm
      const totalTime = 5000;

      const self = this;
      const baseArrowPos = 0; //this._arrow.rotation;

      timerManager.addTimer(
        totalTime,
        function (progress) {
          const easedRotation =
            baseArrowPos +
            Math.sqrt(1 - Math.pow(progress - 1, 2)) * totalSpinDistance; // easing circular

          self._arrow.rotation = easedRotation; //newRotation;

          const emitterAngle = easedRotation - Math.PI / 2;

          const xx = 90 * Math.cos(emitterAngle);
          const yy = 90 * Math.sin(emitterAngle);

          self.emitter.particleEmitter.spawnPos.x = self._arrow.position.x + xx;
          self.emitter.particleEmitter.spawnPos.y = self._arrow.position.y + yy;
        },
        function () {
          self.resultLanded(); /*self._arrow.rotation = spinAngle + ( Math.PI / 2 ); /*totalSpinDistance;*/
        }
      );
    }

    resultLanded() {
      this._localFSIndex++;

      this.emitter.particleEmitter.emit = false;

      if (this._currentWin) {
        soundManager.play(this.gambleWinSounds[this.gambleWinSoundIndex]);

        this.gambleWinSoundIndex++;

        this.gemBurstAnim.gotoAndPlay(0);
        this.blastAnim.gotoAndPlay(0);

        this._currentSpins.setTranslationParameters(
          this._possibleValues[this._localFSIndex]
        );

        this._winIntroAnim.position.set(
          this._winAnimIntroPositions[this._localFSIndex].x,
          this._winAnimIntroPositions[this._localFSIndex].y
        );

        if (
          this._possibleValues[this._localFSIndex] ===
          this._possibleValues[this._possibleValues.length - 1]
        ) {
          this._gambleButton.visible = false;
          this._gambleButton.interactive = false;
        }
      } else {
        this._currentSpins.setTranslationParameters("0");
        this._betterLuckText.visible = true;

        soundManager.play("gambleLose");

        this.stateMachine.switchState("IDLE");
      }

      // allow time to see results - more time on a lose
      const self = this;
      timerManager.addTimer(
        this._currentWin ? 100 : 1000,
        function () {},
        function () {
          if (!self._currentWin) {
            self.visible = false;
          }

          self._resultShownCb();
        }
      );
    }
  }

  let gambleSpinCreator = function (json) {
    return new GambleSpin();
  };

  let gambleSpinInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let gambleSpinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleSpin",
    gambleSpinCreator,
    gambleSpinInitialiser,
    gambleSpinFilesRequired
  );
})();
